// ─── Cómo se agrupan las personas del centro ────────────────────────────────
//
// UNA SOLA DEFINICIÓN, Y VIVE ACÁ PORQUE LA USAN LOS DOS LADOS. La pantalla de
// Personas agrupa para filtrar y contar sus pestañas; el asistente cuenta para
// responder «¿cuántos docentes hay?». Si cada uno llevara su propia lista, el
// día que se agregue un cargo nuevo uno de los dos números cambiaría y el otro
// no — y quien pregunte al asistente teniendo la pantalla delante leería la
// diferencia como un error del sistema.
//
// Es el mismo arreglo que se le hizo a la lista de rutas del asistente, que
// estaba escrita dos veces con un respaldo silencioso en el medio.
//
// UNA PERSONA PUEDE ESTAR EN VARIOS GRUPOS. Un egresado que hoy enseña es
// egresado Y cuerpo docente. No son particiones: son preguntas distintas sobre
// la misma persona, y por eso el total nunca es la suma.
/** Las etapas del ciclo de vida académico. Excluyentes entre sí: una persona
 *  tiene UNA, y `promoteToLifecycleStage` la reemplaza. */
export const LIFECYCLE_TYPES = [
    'student',
    'alumni',
    'prospecto-académico',
    'externo',
    'contact',
];
/** Cargos dentro de la institución. Se acumulan con la etapa del ciclo de vida
 *  y entre sí. */
export const INSTITUTIONAL_ROLE_TYPES = [
    'faculty',
    'docente',
    'tutor',
    'decano',
    'academico',
    'coordinador',
    'capellan',
    'staff',
];
/** Los cargos que enseñan o dirigen lo académico. SUBCONJUNTO de los
 *  institucionales: deja fuera capellanía y personal, que son de la casa pero
 *  no del aula. */
export const TEACHING_ROLE_TYPES = [
    'faculty',
    'docente',
    'tutor',
    'decano',
    'academico',
    'coordinador',
];
/** Roles que da el sistema, no cargos de la institución. */
export const SYSTEM_TYPES = [
    'tenantAdmin',
    'registrar',
    'reviewer',
    'mentor',
    'finance',
    'donor',
];
/** Un cargo puede estar escrito en `types` (histórico) o en
 *  `institutionalRoles` (lo actual). MIRAR UNO SOLO deja gente afuera: las
 *  fichas viejas no tienen el campo nuevo. */
export function hasAnyRole(person, wanted) {
    return ((person.types?.some((t) => wanted.includes(t)) ?? false) ||
        (person.institutionalRoles?.some((r) => wanted.includes(r)) ?? false));
}
export function isInstitutional(person) {
    return hasAnyRole(person, INSTITUTIONAL_ROLE_TYPES);
}
export function isTeachingStaff(person) {
    return hasAnyRole(person, TEACHING_ROLE_TYPES);
}
//# sourceMappingURL=groups.js.map